<template>
  <dashboard-page title="Condutores"
  
    subtitle="equipe de colaboradores"
    >
    <template #actions>
      <div class="d-flex align-items-center search-row">
        <div
          class="d-flex align-items-center w-100"
          style="
            padding: 7px;
            border: 0.5px solid rgb(218, 218, 218);
            border-radius: 5px;
            background-color: white;
            min-width: 20rem;
          "
        >
          <input
            class="search-input w-100"
            style="border: none"
            v-model="searchQuery"
            placeholder="buscar"
          />
          <button
            v-if="searchQuery"
            type="button"
            class="agents-search-clear"
            title="Limpar busca"
            @click="clearSearchQuery"
          >
            <i class="fas fa-times"></i>
            
          </button>

          <i v-else
            class="fas fa-search text-muted"
          ></i>
        </div>
      </div>

      <div class="d-flex align-items-center agents-list-header-actions">
        <button
          type="button"
          class="btn-icon-outline agents-list-search-toggle search-row-mobile"
          :class="{ active: showSearchQuery }"
          @click="toggleSearchQuery"
          title="Buscar condutor"
        >
          <i class="fas fa-search"></i>
        </button>

        <b-row align-self="start" class="row-1 text-right mr-0 mb-0">
          <b-dropdown
            menu
            on
            right
            no-caret
            id="agents-list-actions"
            variant="secondary"
          >
            <template v-slot:button-content>
              <svg
                width="5"
                height="19"
                viewBox="0 0 5 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="2.19231" cy="2.19231" r="2.19231" fill="#12576e" />
                <circle cx="2.19231" cy="9.49992" r="2.19231" fill="#12576e" />
                <circle cx="2.19231" cy="16.8078" r="2.19231" fill="#12576e" />
              </svg>
            </template>

            <b-dropdown-item @click="handleEdit(undefined, -1)" type="default">
              <i class="no no-users"></i> Novo Cadastro
            </b-dropdown-item>

            <b-dropdown-item
              @click="downloadAsCSV"
              :disabled="loadingTable"
              type="default"
            >
              <i v-if="!loadingTable" class="no no-data-download"></i> Download
              CSV
            </b-dropdown-item>
          </b-dropdown>
        </b-row>
      </div>
    </template>

    <div
      class="d-flex align-items-center search-row-mobile px-3 mb-3"
      v-if="showSearchQuery"
    >
      <div
        class="d-flex align-items-center w-100"
        style="
          padding: 7px;
          border: 0.5px solid rgb(218, 218, 218);
          border-radius: 5px;
          background-color: white;
        "
      >
        <i
          class="fas fa-search mr-2"
          style="font-size: 17px; color: lightgrey"
        ></i>
        <input
          class="search-input w-100"
          style="border: none"
          v-model="searchQuery"
          placeholder="Nome, CPF ou CNPJ"
        />
        <button
          v-if="searchQuery"
          type="button"
          class="agents-search-clear"
          title="Limpar busca"
          @click="clearSearchQuery"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>

    <div class="content">
      <modal-loading :openModal="loadingTable" :label="'Carregando... '">
      </modal-loading>

      <b-container fluid class="mt-2">
        <b-row class="mb-4">
          <b-col
            xl="4"
            md="4"
            cols="6"
            :class="`${!isMobileView ? 'mb-0 mb-md-0' : ''}`"
          >
            <stats-card
              title="Habilitados"
              type="gradient-green"
              :sub-title="`${getTotalActive.actives}`"
              :icon="`${!isMobileView ? 'ni ni-check-bold' : ''}`"
            />
          </b-col>
          <b-col
            xl="4"
            md="4"
            cols="6"
            :class="`${!isMobileView ? 'mb-0 mb-md-0' : ''}`"
          >
            <stats-card
              title="Desabilitados"
              type="gradient-orange"
              :sub-title="`${getTotalActive.inactives}`"
              :icon="`${!isMobileView ? 'ni ni-fat-remove' : ''}`"
            />
          </b-col>
          <b-col xl="4" md="4" cols="12">
            <stats-card
              title="Total"
              type="gradient-info"
              :sub-title="`${
                getTotalActive.actives + getTotalActive.inactives
              }`"
              icon="ni ni-single-02"
            />
          </b-col>
        </b-row>

        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <div v-if="isMobileView && !loadingTable" class="agents-list-cards">
            <div v-if="!queriedData.length" class="text-center text-muted py-4">
              Sem registro de condutores.
            </div>
            <agents-list-card
              v-for="(item, index) in queriedData"
              :key="item.uuid || index"
              :agent="item"
              :situation-label="dataFormater(item, 'active')"
              :can-edit="handle_my_place_agents"
              @edit="handleEdit($event, index)"
              @view="handleView"
            />
          </div>

          <b-table
            v-else-if="!loadingTable"
            :items="queriedData"
            :fields="tableColumns"
            :busy="loadingTable"
            head-variant="light"
            striped
            responsive
            :sortDesc="true"
            @selection-change="selectionChange"
            empty-text="nenhum registro encontrado"
          >
            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>carregando...</strong>
              </div>
            </template>

            <template #cell()="data">
              <div>
                {{ dataFormater(data.item, data.field.key) }}
              </div>
            </template>

            <template #cell(acoes)="data">
              <div class="d-flex align-items-center">
                <button

                type="button"
                class="btn-icon mx-1"
                title="Editar registro"
                  v-if="handle_my_place_agents"
                  @click.prevent="handleEdit(data.item, data.index)"
                  
                >
                  <i class="text-white fas fa-pen"></i>
                </button>

                <button

                type="button"
                class="btn-icon mx-1"
                title="Editar registro"
                  v-if="data.item['hasAfiliation']"
                  @click="handleView(data.item['uuid'])"
                  
                >
                  <i class="text-white no no-view"></i>
                </button>
              </div>
            </template>
          </b-table>

          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap align-items-center px-0"
          >
            <div class="d-flex align-items-center flex-wrap mb-2 mb-sm-0">
              <p class="mb-0 mr-3" style="color: gray">
              <el-select
                ref="perPageSelect"
                class=""
                v-model="pagination.perPage"
                placeholder="Por página"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
                <span
                  class="per-page-label font-weight-bold text-primary"
                  @click="openPerPageSelect"
                >
                  <i class="no no-down-arrow"></i>
                  {{ pagination.perPage }}
                </span>
                por página, listando
                <b>{{ from + 1 }}</b> a <b>{{ to }}</b> de
                <span v-if="searchQuery.length">
                  <b>{{ total }}</b> item(s) filtrados(s)
                </span>
                <span v-else>
                  <b>{{ total }}</b> item(s)
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              :value="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
              @change="paginationChanged($event)"
            >
            </base-pagination>
          </div>

          <AgentModal
            v-if="openAgentForm"
            :openAgentForm="openAgentForm"
            :currentAgentAgentData="currentAgentAgentData"
            :agent="agent"
            @emitUpdateAgentRow="emitUpdateAgentRow"
            @closeAgentModal="closeAgentModal"
          >
          </AgentModal>

          <b-modal
            v-model="openAgentCard"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            :size="'xl'"
          >
            <template v-if="agent != null">
              <h2 align-v="start" class="w-100 text-left"></h2>
            </template>

            <agent-card
              class="pt-6 mb-0"
              v-if="openAgentCard"
              v-bind="currentAgentAgentData"
              :agent="currentAgentAgentData.agent"
              :formations="currentAgentAgentData.formations"
              :city="currentAgentAgentData.city"
              :place="currentAgentAgentData.place"
              :mainPlaceAgentData="currentAgentAgentData.mainPlaceAgentData"
              :toggleQR="true"
            />
          </b-modal>
        </card>
      </b-container>
    </div>
  </dashboard-page>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Card from '@/components/Cards/Card.vue'
import { Table, TableColumn, Select, Option } from 'element-ui'
import { BasePagination } from '@/components'
import usePaginateTable from '../../Composables/usePaginateTable'
import AgentModal from './AgentModal.vue'
import AgentCard from '../Agents/AgentCard.vue'
import AgentsListCard from './AgentsListCard.vue'
import ModalLoading from '../../components/ModalLoading/ModalLoading.vue'
import { Modal } from '@/components'
import { hasModule, formatAgentData } from '../../store/utils/users'
import { isMobile } from '../../store/utils/general'
import Swal from 'sweetalert2'
import store from '@/store'

export default {
  component: 'Agents',

  components: {
    Card,
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    AgentModal,
    AgentCard,
    AgentsListCard,
    ModalLoading,
    Modal,
    store,
  },

  setup(props, context) {
    const paginateTable = usePaginateTable(context)

    const total = paginateTable.total
    const from = paginateTable.from
    const to = paginateTable.to
    const queriedData = paginateTable.queriedData
    const pagination = paginateTable.getPagination()
    const billItems = paginateTable.getBillsItems()
    const searchQuery = paginateTable.searchQuery

    function formatDataLocaleString(oldData) {
      return paginateTable.formatDataLocaleString(oldData)
    }

    function sortChange(data) {
      return paginateTable.sortChange(data)
    }

    function createFuseSearch(keys) {
      return paginateTable.createFuseSearch(keys)
    }

    function setBillItems(items) {
      return paginateTable.setBillsItems(items)
    }

    return {
      total,
      from,
      to,
      queriedData,
      pagination,
      billItems,
      searchQuery,
      formatDataLocaleString,
      sortChange,
      createFuseSearch,
      setBillItems,
    }
  },

  data() {
    return {
      selectedRows: [],
      formattedBillItems: [],
      showSearchQuery: false,
      isMobileView: isMobile(),
      tableColumns: [
        { key: 'name', label: 'Nome', minWidth: 100, sortable: true },
        { key: 'active', label: 'Situação', minWidth: 100, sortable: true },
        {
          key: 'place_name',
          label: 'Responsável',
          minWidth: 100,
          sortable: true,
        },
        { key: 'acoes', label: '', minWidth: 100, sortable: false },
      ],
      openAgentForm: false,
      openAgentCard: false,
      agent: null,
      currentAgentAgentData: { agent: { id: 0, name: '' } },
      currentRowUuid: -1,
      currentSearchQuery: '',
      loadingTable: false,
      handle_my_place_agents: false,
      handle_city_agents: false,
      requiredFields: {
        active: { label: 'active', public_label: 'Ativo', type: 'checkbox' },
        changed: {
          label: 'changed',
          public_label: 'Última alteração',
          type: 'hidden_config',
        },
      },
    }
  },

  computed: {
    ...mapGetters('auth', {
      user: 'user',
      place: 'getPlace',
      params: 'params',
    }),

    ...mapState('agent', ['productList']),

    ...mapGetters('agent', {
      agents: 'getAgents',
    }),

    ...mapGetters('product', {
      poisList: 'getPois',
    }),

    getTotalActive() {
      let agValues = Object.values(this.formattedBillItems)
      let actives = agValues.filter((agent) => {
        return agent.active && agent.active === 'true'
      })
      return {
        actives: actives.length,
        inactives: agValues.length - actives.length,
      }
    },
  },

  methods: {
    ...mapActions('agent', ['getAllAgents', 'setAgentData', 'getAgentByUUID']),

    ...mapActions('product', ['fetchPOIs']),

    toggleSearchQuery() {
      this.showSearchQuery = !this.showSearchQuery
    },

    clearSearchQuery() {
      this.searchQuery = ''
    },

    closeAgentModal() {
      this.openAgentForm = false
    },

    formatTableRow(rowData) {
      rowData.currentPlaceHasMainAffiliation = this.place.id == rowData.place_id

      rowData.currentPlaceAffiliationStatus =
        rowData.current_place_id_situation == undefined
          ? { label: 'active', value: 'new' }
          : rowData.current_place_id_situation

      rowData.hasAfiliation = rowData.place_id > 0
      rowData.afiliationStatus = false

      if (rowData.hasAfiliation) {
        rowData.place_name = rowData.Place.name

        if (
          undefined != rowData.Place.City &&
          undefined != rowData.Place.City.State
        ) {
          rowData.place_name += ` (${rowData.Place.City.name} - ${rowData.Place.City.State.namecode})`
        }

        if (undefined == rowData.main_place_id_situation) {
          rowData.place_name += ` | pendente`
        } else {
          rowData.afiliationStatus = rowData.main_place_id_situation.value
            ? rowData.main_place_id_situation.value === 'true' ||
              rowData.main_place_id_situation.value === '1'
            : false

          if (!rowData.currentPlaceHasMainAffiliation) {
            rowData.place_name += ` | ${
              rowData.afiliationStatus ? 'Ativo' : 'Inativo'
            }`
          }
        }
      } else {
        rowData.place_name = ''
      }
      return rowData
    },

    dataFormater(row, prop) {
      let result = row[prop]

      if (prop == 'cpf') {
        if (row[prop] && row[prop].length == 14) {
          result = `***${row[prop].substring(3, 12)}**`
        }
      } else if (prop == 'name') {
        if (row.nickname && row.nickname.trim() != '') {
          result = `${row[prop]} (${row.nickname.trim()})`
        }
      } else if (prop == 'active') {
        result = ``
        if (hasModule('handle_city_agents')) {
          if (
            row.currentPlaceAffiliationStatus != undefined &&
            row.currentPlaceAffiliationStatus.value == 'new'
          ) {
            if (row.logicx == 2 || !row.place_id) {
              result += 'Desvinculado'
            } else {
              result += 'Novo'
            }
          } else {
            result +=
              row.currentPlaceAffiliationStatus != undefined &&
              row.currentPlaceAffiliationStatus.value === 'true'
                ? 'Habilitado'
                : 'Desabilitado'
          }
        } else {
          if (undefined == row.active) {
            if (row.hasAfiliation) {
              result += 'Novo'
            } else {
              result += 'Aguardando aprovação'
            }
          } else if (row.currentPlaceHasMainAffiliation) {
            result += row[prop] === 'true' ? 'Ativo' : 'Inativo'
          } else {
            result += 'Desvinculado'
          }
        }
      }
      return result || '--'
    },

    selectionChange(selectedRows) {
      this.selectedRows = selectedRows
    },

    openPerPageSelect() {
      const select = this.$refs.perPageSelect
      if (!select) return

      // Element UI Select: abre o dropdown sem exibir o input
      if (typeof select.focus === 'function') {
        select.focus()
      }
      select.visible = true
    },

    paginationChanged(page) {
      this.pagination.currentPage = page
    },

    async handleEdit(item, index) {
      let defaultAgentData = {}
      let isAutoRegistered = false
      this.currentSearchQuery = this.searchQuery

      this.agent = {
        category: 'Condutor',
        isNew: true,
        languages: [],
        AgentsPlace: [],
        city_id: this.place.city.id,
        place_id: this.place.id,
        AgentsFormations: [],
      }

      defaultAgentData = {
        Agent: this.agent,
        Place: {},
        AgentsFormations: {},
        AgentsPlace: [],
        City: {},
      }

      if (item && item.uuid == undefined) {
        this.agent.name = item.name
        this.agent.cpf = item.cpf
        this.agent.user_id = item.user_id
        this.agent.nickname = item.nickname
        defaultAgentData.Agent = this.agent
        defaultAgentData.AgentsPlace = [{ xfields: item.userXfields }]
        isAutoRegistered = true
      }

      if (index < 0 || isAutoRegistered) {
        this.currentRowUuid = -1
        this.currentAgentAgentData = formatAgentData(
          defaultAgentData,
          this.getPlaceId(),
          this.getPlaceAgentXFields(),
          { currentUserPois: this.poisList },
          this.requiredFields
        )

        this.openAgentForm = true
      } else {
        await this.getAgentByUUID(item.uuid).then((rsp) => {
          this.currentAgentAgentData = formatAgentData(
            rsp.view,
            this.getPlaceId(),
            this.getPlaceAgentXFields(),
            { currentUserPois: this.poisList },
            this.requiredFields
          )

          this.currentAgentAgentData.agent.currentPlaceHasMainAffiliation =
            item.currentPlaceHasMainAffiliation
          this.currentAgentAgentData.agent.hasAfiliation = item.hasAfiliation
          this.currentAgentAgentData.agent.afiliationStatus =
            item.afiliationStatus
          this.currentAgentAgentData.agent.AgentsFormations =
            this.currentAgentAgentData.formations
          this.currentRowUuid = this.currentAgentAgentData.agent.uuid
          this.agent = this.currentAgentAgentData.agent
          this.openAgentForm = true
        })
      }
    },

    async handleView(agentUuid) {
      await this.getAgentByUUID(agentUuid)
        .then((rsp) => {
          this.currentAgentAgentData = formatAgentData(
            rsp.view,
            this.getPlaceId(),
            this.getPlaceAgentXFields(),
            { currentUserPois: this.poisList },
            this.requiredFields
          )
          this.openAgentCard = true
        })
        .catch((error) => {
          console.error(error)
          Swal.fire({
            title: 'Atenção',
            text: 'Nenhuma informação encontrada! Edite o perfil para inserir informações',
            buttonClass: 'btn btn-error',
            icon: 'warning',
          })
        })
    },

    async populateTable() {
      this.loadingTable = true
      const vm = this
      this.formattedBillItems = Object.values(this.agents).filter(agent => agent.uuid !== undefined).map(function (
        agentVal
      ) {
        return vm.formatTableRow(agentVal)
      })

      this.formattedBillItems.length > 0
        ? this.setBillItems(this.formattedBillItems)
        : this.setBillItems([])
      this.loadingTable = false
    },

    getPlaceId() {
      return this.place.id
    },

    getPlaceAgentXFields() {
      return this.params.AgentXFields
    },

    emitUpdateAgentRow(agentData) {
      this.updateAgentRow(agentData)
    },

    updateAgentRow(agentData) {
      if (false !== agentData) {
        this.searchQuery = ''
        if (this.currentRowUuid == -1) {
          if (agentData.user_id == this.currentAgentAgentData.agent.user_id) {
            Object.values(this.agents).forEach((agent, idx) => {
              if (agent.user_id == agentData.user_id) {
                delete agentData.isNew
                delete this.agents[idx]
                this.currentRowUuid = this.currentAgentAgentData.agent.uuid
              }
            })
          }
          this.agents.unshift(this.formatTableRow(agentData))
          this.populateTable()
        } else {
          Object.values(this.agents).forEach((agent, idx) => {
            if (agent.uuid == this.currentRowUuid) {
              this.agents[idx] = this.formatTableRow(agentData)
              return
            }
          })

          Object.values(this.formattedBillItems).forEach((agent, idx) => {
            if (agent.uuid == this.currentRowUuid) {
              this.formattedBillItems[idx] = this.formatTableRow(agentData)
              return
            }
          })

          this.sortChange({})

          setTimeout(() => {
            let searchTerm = this.currentSearchQuery.trim()
            if (searchTerm) {
              this.searchQuery = this.currentSearchQuery.trim()
            }
          }, 0)
        }
      }
      this.openAgentForm = false
    },

    downloadAsCSV() {
      var mat = []
      if (typeof this.formattedBillItems == 'object') {
        mat = Object.values(this.formattedBillItems).map(function (val) {
          let qrcode = `${window.location.origin}/profile/${val.uuid}`
          qrcode = qrcode.replace(/\\/g, '')

          let birthday = val.birthday
          try {
          } catch (error) {}

          let activits = val.activits
          try {
            activits = activits
              .map((activit) => {
                return activit.value || ''
              })
              .join(' | ')
          } catch (error) {}

          let place_situation = 'Inativo'
          try {
            place_situation = val.main_place_id_situation.value
              ? 'Ativo'
              : 'Inativo'
          } catch (error) {}

          let languages = ''
          try {
            languages = val.languages
              .map((language) => {
                return language.label || '--'
              })
              .join(' | ')
          } catch (error) {}

          var row = [
            `${val.uuid}`,
            `${val.name}`,
            `${qrcode}`,
            `${val.nickname != null ? val.nickname : ''}`,
            `${val.cpf || ''}`,
            `${birthday || ''}`,
            `${val.blodtype ? val.blodtype.value : ''}`,
            `${
              val.City.name +
              (val.City.State ? '-' + val.City.State.namecode : '')
            }`,
            `${val.hasAfiliation ? 'Sim' : 'Não'}`,
            `${val.place_name || ''}`,
            `${place_situation}`,
            `${val.mobile || ''}`,
            `${val.mailaddress || ''}`,
            `${languages}`,
            `${val.cnh ? val.cnh.value : ''}`,
            `${activits}`,
          ]
          return row
        })
      }

      var headers = []
      headers = [
        'ID',
        'Nome',
        'QRCode',
        'Apelido',
        'cpf',
        'Nascimento',
        'Tipo Sanguineo',
        'Cidade',
        'É Associado',
        'Instituição',
        'Situação de associado',
        'Telefone',
        'email',
        'Idiomas',
        'CNH',
        'Atividades',
      ]
      mat.unshift(headers)

      var universalBOM = '\uFEFF'
      let csvContent =
        'data:text/csv;charset=utf-8,' +
        universalBOM +
        mat.map((e) => e.join(';')).join('\n')
      var encodedUri = encodeURI(csvContent)
      var link = document.createElement('a')
      link.setAttribute('href', encodedUri)

      link.setAttribute(
        'download',
        `${this.user.username}_condutores_janoo.csv`
      )

      jQuery('body')
        .append(link)
        .ready(function () {
          link.click()
        })
    },
  },

  async mounted() {
    this.loadingTable = true
    this.handle_my_place_agents = hasModule('handle_my_place_agents')
    this.handle_city_agents = hasModule('handle_city_agents')

    if (this.handle_city_agents) {
      const PLACE_UUID = this.place.uuid || this.place.janooUserUuid
      await this.fetchPOIs({ PLACE_UUID: PLACE_UUID, PRODUCT_UUID: '' })
    } else {
      this.tableColumns = this.tableColumns.filter(
        (column) => column.prop != 'place_name'
      )
    }

    await this.getAllAgents().then(() => (this.loadingTable = false))
    await this.populateTable()
    await this.createFuseSearch(['name', 'mobile', 'nickname', 'cpf'])
  },
}
</script>
<style>
.agents-list-header-actions {
  gap: 0.35rem;
}

.agents-list-search-toggle.active {
  background-color: #eef5f8;
}

.agents-search-clear {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.35rem;
  padding: 0;
  width: 1.35rem;
  height: 1.35rem;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #9aa5b1;
  cursor: pointer;
  flex-shrink: 0;
}

.agents-search-clear:hover {
  background-color: #eef5f8;
  color: #12576e;
}

.per-page-label {
  cursor: pointer;
  user-select: none;
  margin: 0 0 .15rem;
  font-weight: normal !important;
  font-size: 1em;
  padding: .75rem;
  border-radius: 2px;
}

.per-page-label:hover {
  background-color: #eef5f8 !important;
}

.card-footer .el-select {
  width: 0px;
  height: 0px;
  overflow: hidden !important;
}
</style>
